import React, { useRef, useState } from "react";
import BlurImage from "./BlurImage";

const imagesGallery = [
  {
    lowRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/notary-nine%2Flow-res-blur.jpg?alt=media&token=c84fb025-091e-4a38-8959-18a1741190e1",
    highRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2FElemento_page-0001.jpg?alt=media&token=3e3d76d3-4bf3-455a-9f6d-6211e301fed0",
  },
  {
    lowRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/notary-nine%2Flow-res-blur.jpg?alt=media&token=c84fb025-091e-4a38-8959-18a1741190e1",
    highRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2FElemento_page-0002.jpg?alt=media&token=b9561297-8205-4a50-af82-f18e3df855cd",
  },
  {
    lowRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/notary-nine%2Flow-res-blur.jpg?alt=media&token=c84fb025-091e-4a38-8959-18a1741190e1",
    highRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2FElemento_page-0003.jpg?alt=media&token=98e557ac-09b4-4cc2-bf19-64b569a67685",
  },
  {
    lowRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/notary-nine%2Flow-res-blur.jpg?alt=media&token=c84fb025-091e-4a38-8959-18a1741190e1",
    highRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2FElemento_page-0004.jpg?alt=media&token=410b8b76-6e8d-4428-9ab1-8d2fc1360f2c",
  },
  {
    lowRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/notary-nine%2Flow-res-blur.jpg?alt=media&token=c84fb025-091e-4a38-8959-18a1741190e1",
    highRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fmejoras-pokedex.png?alt=media&token=a55b4544-0054-4442-98d7-e7037e790f19",
  },
  {
    lowRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/notary-nine%2Flow-res-blur.jpg?alt=media&token=c84fb025-091e-4a38-8959-18a1741190e1",
    highRes:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fwho-is.png?alt=media&token=b07e2dbf-19df-48cc-84f6-8bba85207d2f",
  },
];

const Gallery = () => {
  const scrollRef = useRef(null);
  const [modalOpenGal, setModalGalOpen] = useState(false);
  const [modalSrcGal, setModalGalSrc] = useState("");

  const openModal = (highResUrl) => {
    setModalGalSrc(highResUrl);
    setModalGalOpen(true);
  };
  const closeModal = () => {
    setModalGalOpen(false);
    setModalGalSrc("");
  };

  const scrollLeft = () => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    // Scroll negativo por un "ancho de vista" (una página)
    container.scrollBy({
      left: -container.clientWidth,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    // Scroll positivo por un "ancho de vista"
    container.scrollBy({
      left: container.clientWidth,
      behavior: "smooth",
    });
  };

  return (
    <section>
      <div className="gallery-wrapper">
        {/* Botón izquierda */}
        <button className="gallery-button left" onClick={scrollLeft}>
          &#8249;
        </button>

        {/* Contenedor de scroll */}
        <div ref={scrollRef} className="gallery-container-gal">
          {imagesGallery.map((img, index) => (
            <div
              key={index}
              className="gallery-item-gal"
              onClick={() => openModal(img.highRes)}
            >
              <BlurImage
                lowRes={img.lowRes}
                highRes={img.highRes}
                alt={`Instalación ${index + 1}`}
                height="220px"
              />
            </div>
          ))}
        </div>

        {/* Botón derecha */}
        <button className="gallery-button right" onClick={scrollRight}>
          &#8250;
        </button>
      </div>

      {/* ---------- Modal ---------- */}
      {modalOpenGal && (
        <div className="modal-overlay-gallery" onClick={closeModal}>
          <div
            className="modal-content-gal"
            onClick={
              (e) => e.stopPropagation() /* Evita cerrar al hacer clic dentro */
            }
          >
            <button className="modal-close-gal" onClick={closeModal}>
              &times;
            </button>
            <img src={modalSrcGal} alt="Instalación en grande" />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
